export default __webpack_public_path__ + "static/media/285.e9087277.jpg";